/* TOPNAVI — Airtable header behavior
   Vanilla JS, no jQuery. Loaded with `defer` from layout/theme.liquid. */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    initMobileDrawer();
    initSearchOverlay();
    initStickyHeader();
    initMegaMenu();
    initPredictiveSearch();
    initHeaderSearchDropdown();
    // 2026-09-06: initMega2() és initDrawerPanels() a Section Rendering API-n át
    // beérkező panelekre fut (ensureMega / ensureDrawerPanels) — a fejléc HTML-je
    // már nem hordozza a nehéz menü-paneleket. initMenuImagePrefetch() kikerült:
    // a képek ütemezését a beérkezés utáni eagerImgs/chunked végzi.
    initLazyMega();
  }

  /* ---------------------------------------------------------------------
     KÉP-SEGÉDEK — lazy → eager váltás (display:none alatt is indul a
     letöltés; nulla extra kérés, csak ütemezés).
     --------------------------------------------------------------------- */
  const tnConn = navigator.connection || {};
  const tnFast = !tnConn.saveData && !/(^|-)[23]g$/.test(tnConn.effectiveType || '');
  const tnIdle = window.requestIdleCallback
    ? cb => requestIdleCallback(cb, { timeout: 2500 })
    : cb => setTimeout(cb, 250);

  function eagerImgs(root) {
    if (!root) return;
    root.querySelectorAll('img[loading="lazy"]').forEach(img => { img.loading = 'eager'; });
  }
  function chunked(root) {
    const imgs = Array.from(root ? root.querySelectorAll('img[loading="lazy"]') : []);
    let i = 0;
    (function step() {
      const end = Math.min(i + 14, imgs.length);
      for (; i < end; i++) imgs[i].loading = 'eager';
      if (i < imgs.length) tnIdle(step);
    })();
  }

  /* ---------------------------------------------------------------------
     SECTION RENDERING API (2026-09-06, PSI/HTML-méret) — a menü nehéz
     részei NEM utaznak az oldal HTML-jében, hanem igény szerint jönnek:
       · asztali megamenü-panelek:  {root}?sections=tn-mega-lazy
       · mobil fiók L2/L3 paneljei: {root}?sections=tn-drawer-lazy
     Előtte a fejléc-szekció 229 KB / ~350 <img> volt MINDEN oldalon
     (ebből 111 KB a <template>-ben ülő fiók). A SEO-linkek a fejlécben
     maradnak (snippets/tn-mega-seo-links, szöveges lista).
     Cache: sessionStorage, 30 perc, témánként és nyelvenként — a második
     oldalletöltéstől nincs hálózati kérés.
     --------------------------------------------------------------------- */
  const TN_LAZY_VER = 'v1';
  function tnRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function tnCacheKey(id) {
    const th = (window.Shopify && window.Shopify.theme && window.Shopify.theme.id) || '';
    return 'tn:' + id + ':' + TN_LAZY_VER + ':' + th + ':' + tnRoot();
  }
  function fetchSection(id) {
    try {
      const c = sessionStorage.getItem(tnCacheKey(id));
      if (c) {
        const o = JSON.parse(c);
        if (o && o.h && Date.now() - o.t < 1800000) return Promise.resolve(o.h);
      }
    } catch (e) { /* privát mód / tiltott storage: megyünk hálózatról */ }
    return fetch(tnRoot() + '?sections=' + encodeURIComponent(id), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(r => { if (!r.ok) throw new Error('sections ' + r.status); return r.json(); })
      .then(j => {
        const h = j && j[id] ? j[id] : '';
        if (!h) throw new Error('empty section ' + id);
        try { sessionStorage.setItem(tnCacheKey(id), JSON.stringify({ t: Date.now(), h: h })); } catch (e) {}
        return h;
      });
  }
  function parseHtml(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  /* ── Mobil fiók: az L1 lista inline (header.liquid), L2/L3 lusta ───── */
  let drawerPanelsPromise = null;
  function ensureDrawerPanels() {
    if (drawerPanelsPromise) return drawerPanelsPromise;
    const dp = document.querySelector('[data-dp]');
    const holder = document.querySelector('[data-dp-lazy]');
    if (!dp) { drawerPanelsPromise = Promise.resolve(); return drawerPanelsPromise; }
    if (!holder) { drawerPanelsPromise = Promise.resolve(); initDrawerPanels(); return drawerPanelsPromise; }
    drawerPanelsPromise = fetchSection('tn-drawer-lazy').then(html => {
      const src = parseHtml(html).querySelector('[data-dp-lazy-content]');
      if (src) { while (src.firstChild) dp.appendChild(src.firstChild); }
      holder.remove();
      initDrawerPanels();
      if (tnFast) chunked(dp); // a következő szintek képei üresjáratban
    }).catch(() => {
      drawerPanelsPromise = null; // a következő megnyitás újrapróbálja
    });
    return drawerPanelsPromise;
  }

  /* ── Asztali megamenü: a panelek beérkezés után kapják az initMega2-t ── */
  let megaPromise = null;
  function ensureMega() {
    if (megaPromise) return megaPromise;
    const holders = document.querySelectorAll('.tn-megamenu[data-mega-lazy]');
    if (!holders.length) { megaPromise = Promise.resolve(); return megaPromise; }
    megaPromise = fetchSection('tn-mega-lazy').then(html => {
      const doc = parseHtml(html);
      holders.forEach(h => {
        const src = doc.querySelector('[data-mega-for="' + CSS.escape(h.dataset.megaLazy) + '"]');
        if (!src) return;
        h.querySelectorAll('.tn-mega-loading, .tn-mega-seo').forEach(el => el.remove());
        while (src.firstChild) h.appendChild(src.firstChild);
        h.classList.add('is-loaded');
        initMega2(h);
        // Képek: a látható részek azonnal, a többi darabolva üresjáratban
        eagerImgs(h.querySelector('.tn-mega2-side'));
        eagerImgs(h.querySelector('.tn-mega2-foot'));
        h.querySelectorAll('.tn-mega2-card-img, .tn-mega2-panel.is-active').forEach(el => eagerImgs(el));
        if (tnFast) chunked(h);
      });
    }).catch(() => { megaPromise = null; });
    return megaPromise;
  }
  function initLazyMega() {
    const nav = document.querySelector('.tn-nav');
    if (!nav || !document.querySelector('.tn-megamenu[data-mega-lazy]')) return;
    const trigger = () => { ensureMega(); };
    ['mouseenter', 'pointerdown', 'touchstart', 'focusin'].forEach(ev => {
      nav.addEventListener(ev, trigger, { once: true, passive: true });
    });
    // Hover-képes, ≥1024 px-es eszközön előtöltés üresjáratban, hogy az első
    // nyitás is azonnali legyen; adatkímélő módban / 2g-3g-n nem.
    const canWarm = !!(window.matchMedia && window.matchMedia('(min-width: 1024px) and (hover: hover)').matches) && tnFast;
    if (canWarm) {
      if (document.readyState === 'complete') tnIdle(trigger);
      else window.addEventListener('load', () => tnIdle(trigger), { once: true });
    }
  }

  /* ---------------------------------------------------------------------
     MOBILE DRAWER
     --------------------------------------------------------------------- */
  function initMobileDrawer() {
    const toggle = document.querySelector('[data-mobile-toggle]');
    const drawer = document.querySelector('[data-mobile-drawer]');
    const overlay = document.querySelector('[data-drawer-overlay]');
    if (!toggle || !drawer || !overlay) return;

    /* 2026-09-23 (a11y-5): nyitáskor a fókusz a fiókba kerül (Bezárás gomb),
       a Tab a fiókon belül marad, záráskor (Esc is) visszakerül a Menü
       gombra. A fiókot a theme.liquid MutationObservere mikrotaszkban fedi
       fel (addig display:none), ezért a fókusz rAF-ben mozdul.
       Az overlay inline display:none-ját eddig semmi nem vette le, így a
       sötétítés és a „kívülre koppintva zár” nem működött — most az open()
       leveszi (rejtett állapotban az airtable.css opacity:0/visibility:hidden
       szabálya tartja láthatatlanul). */
    function focusables() {
      return [].filter.call(
        drawer.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'),
        el => !el.disabled && !el.closest('[inert]') && !el.closest('[hidden]') && el.getClientRects().length
      );
    }
    function open(e) {
      ensureDrawerPanels(); // 2026-09-02: a panelek első nyitáskor klónozódnak be
      overlay.style.display = '';
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');
      // Billentyűs nyitásnál (click detail 0) a Bezárás gomb kap fókuszt (látható
      // kerettel); érintésnél/egérnél maga a fiók, keret nélkül — a Tab innen is
      // a fiók első elemére lép, és a képernyőolvasó is a fiókban marad.
      const kb = !e || e.detail === 0;
      requestAnimationFrame(() => {
        if (!drawer.classList.contains('is-open')) return;
        const btn = kb && drawer.querySelector('.tn-drawer-close');
        if (btn) { btn.focus({ preventScroll: true }); return; }
        if (!drawer.hasAttribute('tabindex')) drawer.setAttribute('tabindex', '-1');
        drawer.focus({ preventScroll: true });
      });
    }
    function close() {
      const hadFocus = drawer.contains(document.activeElement);
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      toggle.setAttribute('aria-expanded', 'false');
      if (hadFocus) toggle.focus({ preventScroll: true });
    }

    toggle.addEventListener('click', open);
    overlay.addEventListener('click', close);
    drawer.querySelectorAll('[data-drawer-close]').forEach(el => el.addEventListener('click', close));
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        close();
        // Esc-re is a főmenü nézet álljon vissza (eddig csak kattintásos zárásnál)
        const dp = document.querySelector('[data-dp]');
        if (dp && dp._tnReset) dp._tnReset();
      }
    });
    drawer.addEventListener('keydown', e => {
      if (e.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
      const f = focusables();
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      const inside = drawer.contains(document.activeElement);
      if (e.shiftKey && (!inside || document.activeElement === first || document.activeElement === drawer)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (!inside || document.activeElement === last)) { e.preventDefault(); first.focus(); }
    });

    // 2026-07-28: a régi accordion-ág ([data-submenu-toggle]) törölve —
    // a 2026-07-21-es panel-drawer óta nem létezik ilyen markup.
  }

  /* ---------------------------------------------------------------------
     SEARCH OVERLAY
     --------------------------------------------------------------------- */
  function initSearchOverlay() {
    const triggers = document.querySelectorAll('[data-search-toggle]');
    const overlay = document.querySelector('[data-search-overlay]');
    if (!triggers.length || !overlay) return;
    const input = overlay.querySelector('[data-search-input]');
    const panel = overlay.querySelector('.tn-search-panel');

    function updatePanelPadding() {
      const header = document.querySelector('.tn-header');
      if (!header || !panel) return;
      const bottom = Math.max(0, header.getBoundingClientRect().bottom);
      panel.style.paddingTop = (bottom + 28) + 'px';
    }

    function open() {
      updatePanelPadding();
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (input) setTimeout(() => input.focus(), 80);
    }
    function close() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    // 2026-07-12 (browser-review): a scroll-listener törölve — a panel
    // position:fixed, a header sticky, így a header alsó éle nem mozdul, amíg
    // az overlay nyitva van; az open()-kori egyszeri mérés + resize elegendő.
    // (iOS Safarin a body overflow:hidden nem állítja meg a scrollt, ott ez
    // minden scroll-frame-en forced layout + relayout volt.)
    window.addEventListener('resize', updatePanelPadding);

    triggers.forEach(t => t.addEventListener('click', open));
    overlay.querySelectorAll('[data-search-close]').forEach(el => el.addEventListener('click', close));
    overlay.addEventListener('click', e => {
      if (e.target === overlay) close();
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });

    // Expose toggle for header inline icons (legacy compatibility)
    window.toggleSearch = function () {
      overlay.classList.contains('is-open') ? close() : open();
    };
  }

  /* ---------------------------------------------------------------------
     STICKY HEADER (shadow on scroll)
     --------------------------------------------------------------------- */
  function initStickyHeader() {
    const header = document.querySelector('[data-at-header]');
    if (!header) return;

    /* 2026-09-04 — VILLOGÁS-JAVÍTÁS.
       User: „ha nem húzódik fel teljesen az oldal, akkor elkezd villogni
       a felső menü."

       Visszacsatolási hurok volt. Az `is-scrolled` a fejlécet 76-ról
       62 px-re zsugorítja, ezzel az OLDAL is 14 px-szel rövidebb lesz.
       Ha a lap alig hosszabb a képernyőnél, a böngésző a rövidebb laphoz
       igazítja a görgetést, a scrollY visszaesik a küszöb alá, a fejléc
       visszanő, az oldal megnyúlik — és kezdődik elölről, képkockánként.

       Két védelem:
       1. HISZTERÉZIS: zsugorodni 64 px-nél kezd, visszanőni csak 24 px
          alatt. A 40 px-es holtsáv jóval nagyobb a 14 px-es magasság-
          változásnál, így a hurok nem tud beindulni.
       2. Ha a lapon nincs érdemi görgetési tartalék (120 px alatt),
          egyáltalán nem zsugorodik — ott a zsugorodásnak nincs is
          értelme, viszont pont ott a legkockázatosabb. */
    const SHRINK_AT = 64;
    const GROW_UNDER = 24;
    const MIN_ROOM = 120;

    // 2026-09-25 (sebesség): a scrollHeight olvasása elrendezést kényszerít — nem minden görgetésnél, csak
    // betöltés után és átméretezéskor mérjük (rAF-ben, a festés után).
    let room = Infinity;
    function measure() { requestAnimationFrame(() => { room = document.documentElement.scrollHeight - window.innerHeight; onScroll(); }); }
    function onScroll() {
      const y = window.scrollY;
      if (room < MIN_ROOM) { header.classList.remove('is-scrolled'); return; }
      if (y > SHRINK_AT) header.classList.add('is-scrolled');
      else if (y < GROW_UNDER) header.classList.remove('is-scrolled');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure, { passive: true });
    if (document.readyState === 'complete') measure(); else window.addEventListener('load', measure, { once: true });
    onScroll();
  }

  /* ---------------------------------------------------------------------
     MEGA-MENU — aria-expanded szinkron a CSS-hover nyitáshoz (2026-07-28).
     A régi `no-delay` osztály-togglet töröltük: egyetlen .tn-* CSS-szabály
     sem használta (csak az inaktív turbo-header réteg). A nyitás/zárás
     továbbra is tisztán CSS (:hover/:focus-within) — ez csak a képernyő-
     olvasóknak jelzi az állapotot.
     --------------------------------------------------------------------- */
  /* 2026-09-23 (a11y-12, WCAG 1.4.13): Esc-re a nyitott lenyíló bezárul.
     A nyitás CSS (:hover/:focus-within), ezért a zárás egy `is-dismissed`
     osztály (tn-menu.css), ami erősebb a hover/focus-within szabálynál;
     egér-elhagyáskor, illetve ha a fókusz kilép a menüpontból, lekerül.
     A <button> típusú menüpont billentyűzettel (Enter/Space) váltja a
     lenyílót — az egérkattintás viselkedése nem változik. */
  function initMegaMenu() {
    document.querySelectorAll('.tn-nav-item.has-dropdown').forEach(item => {
      const link = item.querySelector(':scope > .tn-nav-link');
      if (!link) return;
      link.setAttribute('aria-expanded', 'false');
      const set = v => link.setAttribute('aria-expanded', v);
      const dismiss = () => { item.classList.add('is-dismissed'); set('false'); };
      const undismiss = () => { item.classList.remove('is-dismissed'); };
      item.addEventListener('mouseenter', () => { if (!item.classList.contains('is-dismissed')) set('true'); });
      item.addEventListener('mouseleave', () => { undismiss(); set('false'); });
      item.addEventListener('focusin', () => { if (!item.classList.contains('is-dismissed')) set('true'); });
      item.addEventListener('focusout', e => {
        if (!item.contains(e.relatedTarget)) { undismiss(); set('false'); }
      });
      item.addEventListener('keydown', e => {
        if (e.key === 'Escape' && !item.classList.contains('is-dismissed')) {
          dismiss();
          if (item.contains(document.activeElement) && document.activeElement !== link) link.focus({ preventScroll: true });
        }
      });
      if (link.tagName === 'BUTTON') {
        link.addEventListener('keydown', e => {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          if (item.classList.contains('is-dismissed')) { undismiss(); set('true'); ensureMega(); }
          else dismiss();
        });
      }
    });
  }

  /* ---------------------------------------------------------------------
     MEGA2 — kétpaneles megamenü (2026-07-21): márkára hoverelve/fókuszálva
     a jobb oldali modell-panel vált; a kereső a márkalistát szűri.
     Markup: snippets/tn-mega-2026.liquid, stílus: assets/tn-menu.css.
     --------------------------------------------------------------------- */
  function initMega2(root) {
    (root || document).querySelectorAll('[data-mega2]').forEach(mega => {
      const brands = mega.querySelectorAll('[data-mega2-brand]');
      const panels = mega.querySelectorAll('[data-mega2-panel]');

      function activate(key) {
        brands.forEach(b => b.classList.toggle('is-active', b.dataset.mega2Brand === key));
        panels.forEach(p => {
          const on = p.dataset.mega2Panel === key;
          if (on) eagerImgs(p); // a célpanel képei azonnal induljanak
          p.classList.toggle('is-active', on);
        });
      }

      // Hover-intent: 90ms késleltetéssel vált, így a márkalistáról a
      // modell-kártyák felé húzott (átlós) egérmozgás közben érintett
      // sorok NEM váltják el a panelt (klasszikus megamenü-hiba).
      let hoverTimer = null;
      brands.forEach(b => {
        b.addEventListener('mouseenter', () => {
          clearTimeout(hoverTimer);
          // A képek letöltése már a hover-intent ELŐTT induljon
          eagerImgs(mega.querySelector('[data-mega2-panel="' + CSS.escape(b.dataset.mega2Brand) + '"]'));
          hoverTimer = setTimeout(() => activate(b.dataset.mega2Brand), 90);
        });
        b.addEventListener('mouseleave', () => clearTimeout(hoverTimer));
        b.addEventListener('focus', () => activate(b.dataset.mega2Brand));
      });

      /* Kereső (2026-07-21 user-kérés): márkán túl MODELLT is találjon;
         ha egyik sincs, TERMÉK-javaslatot ad (márkaspecifikus multimédia
         előre sorolva). A modell-index a már renderelt kártyákból épül —
         nulla extra adat, a találat a kártya klónja. */
      const input = mega.querySelector('[data-mega2-filter]');
      const empty = mega.querySelector('[data-mega2-empty]');
      const resModels = mega.querySelector('[data-mega2-search-models]');
      const resProds = mega.querySelector('[data-mega2-search-products]');
      const resNone = mega.querySelector('[data-mega2-search-none]');
      const resTitle = mega.querySelector('[data-mega2-search-title]');

      const modelIndex = [];
      panels.forEach(p => {
        if (p.dataset.mega2Panel === '__search') return;
        const brandEl = mega.querySelector('[data-mega2-brand="' + CSS.escape(p.dataset.mega2Panel) + '"]');
        const brandName = brandEl ? (brandEl.dataset.brandName || '') : '';
        p.querySelectorAll('.tn-mega2-models > li').forEach(li => {
          modelIndex.push({ text: (brandName + ' ' + li.textContent).toLowerCase(), li: li });
        });
      });

      if (input) {
        let prodTimer = null;
        const defaultBrand = mega.querySelector('.tn-mega2-brand.is-active');
        const defaultKey = defaultBrand ? defaultBrand.dataset.mega2Brand : (brands[0] ? brands[0].dataset.mega2Brand : '');
        const resultsLabel = resTitle ? resTitle.textContent : '';
        input.addEventListener('input', () => {
          const q = input.value.trim().toLowerCase();
          clearTimeout(prodTimer);
          let visible = 0;
          brands.forEach(b => {
            const li = b.closest('li');
            const match = !q || (b.dataset.brandName || '').includes(q);
            if (li) li.classList.toggle('is-hidden', !match);
            if (match) visible++;
          });
          if (empty) empty.hidden = true;
          if (resNone) resNone.hidden = true;

          if (!q) {
            if (resModels) { resModels.hidden = true; resModels.innerHTML = ''; }
            if (resProds) { resProds.hidden = true; resProds.innerHTML = ''; }
            if (defaultKey) activate(defaultKey);
            return;
          }

          const modelHits = modelIndex.filter(m => m.text.includes(q)).slice(0, 8);
          if (resTitle) resTitle.textContent = resultsLabel + ': „' + input.value.trim() + '”';

          if (modelHits.length) {
            resModels.innerHTML = '';
            modelHits.forEach(m => resModels.appendChild(m.li.cloneNode(true)));
            resModels.hidden = false;
            if (resProds) { resProds.hidden = true; resProds.innerHTML = ''; }
            activate('__search');
          } else if (visible > 0) {
            // Márka-találat van, modell nincs: az első látható márka panelje
            if (resModels) { resModels.hidden = true; resModels.innerHTML = ''; }
            if (resProds) { resProds.hidden = true; resProds.innerHTML = ''; }
            const first = mega.querySelector('.tn-mega2-brands li:not(.is-hidden) [data-mega2-brand]');
            if (first) activate(first.dataset.mega2Brand);
          } else {
            // Se márka, se modell: termék-javaslat (rövid késleltetéssel)
            resModels.hidden = true; resModels.innerHTML = '';
            activate('__search');
            prodTimer = setTimeout(() => {
              suggestProducts(input.value.trim(), resProds, resNone);
            }, 250);
          }
        });
        input.addEventListener('click', e => e.stopPropagation());
      }
    });
  }

  /* Termék-javaslatok a menü-keresőkbe: /search/suggest.json, a
     "Márkaspecifikus multimédia" vendor előre sorolva (user-kérés), a
     meglévő .at-search-result stílusokat újrahasznosítva. */
  function suggestProducts(query, container, noneEl) {
    if (!container) return;
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8')
      .then(r => r.json())
      .then(data => {
        const found = (data.resources && data.resources.results && data.resources.results.products) || [];
        const products = relevantProducts(found, query);
        products.sort((a, b) => vendorPriority(b.vendor) - vendorPriority(a.vendor));
        if (!products.length) {
          container.hidden = true;
          container.innerHTML = '';
          if (noneEl) noneEl.hidden = false;
          return;
        }
        if (noneEl) noneEl.hidden = true;
        container.innerHTML = groupedResultsHtml(products, p => `
          <a href="${p.url}" class="at-search-result">
            <div class="at-search-result-image">
              <img src="${searchThumb(p.image, 200)}" alt="${escapeHtml(p.title)}" loading="lazy" width="96" height="96">
            </div>
            <div class="at-search-result-info">
              <div class="at-search-result-title">${escapeHtml(p.title)}</div>
              <div class="at-search-result-price">${searchMoney(p)}</div>
            </div>
          </a>`);
        container.hidden = false;
      })
      .catch(() => { /* hálózati hiba: a kereső némán marad, a menü működik */ });
  }

  /* ---------------------------------------------------------------------
     DRAWER PANELS — mobil csúszó-paneles menü (2026-07-21): a mélyebb
     szint teljes panelként csúszik be, "← Vissza" léptet visszafelé.
     Markup: snippets/tn-drawer-panels.liquid, stílus: assets/tn-menu.css.
     --------------------------------------------------------------------- */
  function initDrawerPanels() {
    const dp = document.querySelector('[data-dp]');
    if (!dp || dp.dataset.tnInit) return;
    dp.dataset.tnInit = '1';
    const panels = dp.querySelectorAll('[data-dp-panel]');
    let stack = ['root'];

    /* 2026-09-23 (a11y-5): a nem aktív panelek `inert`-et kapnak — eddig csak
       translateX tolta félre őket, így ~250 láthatatlan sor volt Tab-bal és
       képernyőolvasóval bejárható. Az inert a megjelenést nem érinti, a
       0,28 s-os csúszás marad. Mivel a lenyitó sor így inertté válik, a fókuszt
       (ha a fiókban volt) az új panel vissza-gombjára, visszalépéskor pedig az
       előző szint lenyitó sorára visszük. */
    function show(id, focusTo) {
      const next = dp.querySelector('[data-dp-panel="' + CSS.escape(id) + '"]');
      if (!next) return;
      eagerImgs(next); // a célpanel képei azonnal induljanak
      const hadFocus = dp.contains(document.activeElement);
      panels.forEach(p => { p.classList.remove('is-active', 'is-left'); p.inert = p !== next; });
      // A vissza-útvonal paneljei balra "parkolnak" (mélység-érzet)
      stack.slice(0, -1).forEach(backId => {
        const back = dp.querySelector('[data-dp-panel="' + CSS.escape(backId) + '"]');
        if (back) back.classList.add('is-left');
      });
      next.classList.add('is-active');
      next.scrollTop = 0;
      if (hadFocus) {
        const target = (focusTo && next.querySelector(focusTo)) || next.querySelector('[data-dp-back]');
        if (target) target.focus({ preventScroll: true });
      }
    }

    dp.addEventListener('click', e => {
      const opener = e.target.closest('[data-dp-open]');
      if (opener) {
        e.preventDefault();
        stack.push(opener.dataset.dpOpen);
        show(opener.dataset.dpOpen);
        return;
      }
      const back = e.target.closest('[data-dp-back]');
      if (back) {
        e.preventDefault();
        const from = stack.length > 1 ? stack.pop() : null;
        show(stack[stack.length - 1], from ? '[data-dp-open="' + CSS.escape(from) + '"]' : null);
      }
    });

    // 2026-09-04 user-kérés: „mobilon ne mindig a multimédia menüpontot
    // mutassa, hanem a főmenüt, ha megnyitjuk".
    //
    // ELŐZMÉNY: 2026-07-21-én a kérés PONT az ellenkezője volt (nyíljon
    // rögtön a márkalistával), ezért kapott a márka-ágas panel egy
    // `data-dp-default` jelölést, és a fiók nyitáskor arra ugrott. Emiatt a
    // menü mindig a Multimédia > márkalista nézettel indult, és a többi
    // menüpont (Kiegészítők, Menetrögzítő, Diagnosztika…) csak egy „Főmenü"
    // vissza-lépés után látszott.
    //
    // Mostantól MINDIG a gyökér lista az induló nézet. A `data-dp-default`
    // attribútum a snippetből kikerült; ha valaki visszateszi, ez a függvény
    // akkor sem veszi figyelembe.
    function goDefault() {
      stack = ['root'];
      show('root');
    }
    goDefault();
    function resetSoon() { setTimeout(goDefault, 320); }
    dp._tnReset = resetSoon; // az Esc-es zárás (initMobileDrawer) is ezt hívja
    document.querySelectorAll('[data-drawer-close], [data-drawer-overlay]').forEach(el => {
      el.addEventListener('click', resetSoon);
    });

    // Kereső a mobil márkapanelen: márka + modell találatok, végső
    // esetben termék-javaslat (desktoppal azonos logika, sor-formában).
    dp.querySelectorAll('[data-dp-filter]').forEach(input => {
      const panel = input.closest('[data-dp-panel]');
      if (!panel) return;
      const rows = panel.querySelectorAll('[data-dp-filter-list] li[data-brand-name]');
      const empty = panel.querySelector('[data-dp-empty]');
      const resModels = panel.querySelector('[data-dp-search-models]');
      const resProds = panel.querySelector('[data-dp-search-products]');

      // Modell-index a márka-alpanelek már renderelt soraiból
      const modelIndex = [];
      dp.querySelectorAll('[data-dp-panel^="b-"]').forEach(bp => {
        const backLabel = bp.querySelector('[data-dp-back] span');
        const brandName = backLabel ? backLabel.textContent.toLowerCase() : '';
        bp.querySelectorAll('.tn-dp-list > li').forEach(li => {
          modelIndex.push({ text: (brandName + ' ' + li.textContent).toLowerCase(), li: li });
        });
      });

      let prodTimer = null;
      input.addEventListener('input', () => {
        const q = input.value.trim().toLowerCase();
        clearTimeout(prodTimer);
        let visible = 0;
        rows.forEach(li => {
          const match = !q || (li.dataset.brandName || '').includes(q);
          li.style.display = match ? '' : 'none';
          if (match) visible++;
        });
        if (empty) empty.hidden = true;

        if (!q) {
          if (resModels) { resModels.hidden = true; resModels.innerHTML = ''; }
          if (resProds) { resProds.hidden = true; resProds.innerHTML = ''; }
          return;
        }

        const modelHits = modelIndex.filter(m => m.text.includes(q)).slice(0, 8);
        if (resModels) {
          resModels.innerHTML = '';
          modelHits.forEach(m => resModels.appendChild(m.li.cloneNode(true)));
          resModels.hidden = modelHits.length === 0;
        }

        if (!visible && !modelHits.length) {
          prodTimer = setTimeout(() => {
            suggestProducts(input.value.trim(), resProds, empty);
          }, 250);
        } else if (resProds) {
          resProds.hidden = true;
          resProds.innerHTML = '';
        }
      });
    });
  }

  /* 2026-07-28: initBrandFilter törölve — a [data-brand-filter] markup csak
     az inaktív mega-menu-modern.liquid-ben létezett (2026-07-21 óta halott). */

  /* ---------------------------------------------------------------------
     PREDICTIVE SEARCH — preserves CR-V/CX-5 normalization from legacy
     --------------------------------------------------------------------- */
  // Márkák / rövidítések, amiket NE alakítson át a normalizer
  const NEVER_NORMALIZE = new Set([
    'BMW','AMG','AUDI','OPEL','KIA','VW','SEAT','TDI','TSI','TFSI','GTD','FSI','GTI','GTS','GTR','GTX',
    'AWD','FWD','RWD','SUV','HEV','PHEV','EV','MID','HQ','HD','USB','GPS','DSP','DAB','LED','OEM',
    'ECO','MPV','RS','RS3','RS4','RS5','RS6','RS7'
  ]);
  // Csak ezek a 3-betűs prefixek kapnak CR-V stílusú kötőjelezést
  const KNOWN_V_PREFIXES = new Set(['CR','HR','BR','ZR','WR','XR']);

  function normalizeCarModelQuery(raw) {
    const q = raw.trim();
    // Ha az input MÁR strukturált (tartalmaz szóközt, kötőjelet, vagy pontot),
    // a user explicit "márka + modell" formát írt — tiszteletben tartjuk és
    // változatlanul küldjük tovább. ("Audi A3", "BMW E46", "Toyota RAV4", "CR-V" stb.)
    if (/[\s\-\.]/.test(q)) return q;

    // Csak ezután fut a model-kód normalizáló — pl. "CRV" → "CR-V", "CX5" → "CX-5".
    const clean = q.toUpperCase();
    if (NEVER_NORMALIZE.has(clean)) return q;
    const map = {
      'CRV': 'CR-V', 'HRV': 'HR-V', 'BRV': 'BR-V', 'ZRV': 'ZR-V', 'WRV': 'WR-V',
      'CX5': 'CX-5', 'CX3': 'CX-3', 'CX30': 'CX-30', 'CX60': 'CX-60', 'CX90': 'CX-90',
      'RAV4': 'RAV 4', 'CHR': 'C-HR', 'TROC': 'T-Roc', 'TCROSS': 'T-Cross',
    };
    if (map[clean]) return map[clean];
    if (clean.length === 3 && clean.endsWith('V') && KNOWN_V_PREFIXES.has(clean.slice(0, 2))) {
      return clean.slice(0, 2) + '-V';
    }
    const m = clean.match(/^([A-Z]{1,5})([0-9]{1,3})([A-Z]{0,2})$/);
    if (m) return m[1] + '-' + m[2] + (m[3] ? ' ' + m[3] : '');
    return q;
  }

  /* ═══ KERESESI TALALAT: kep + ar  ·  2026-09-04 ═══
     User: „a keresésben legyenek kicsit nagyobbak a képek… ha van akció
     akkor ott is mutassa."

     A suggest.json a képet a boltban tárolt méretben adja vissza, ami a
     korábbi 56 px-es dobozhoz készült. A Shopify CDN `width=` paramétere
     AVIF-fel is működik (a régi Liquid img_url szűrő nem tudta méretezni),
     így pont akkorát kérünk, amekkora kell — retina miatt kétszereset. */
  function searchThumb(url, w) {
    if (!url) return '';
    try {
      const u = new URL(url, location.origin);
      u.searchParams.set('width', String(w));
      return u.href;
    } catch (e) {
      return url;
    }
  }

  /* Akciós ár a találatlistában. A suggest.json az eredeti árat
     `compare_at_price_min`-ben adja (régebbi boltokban
     `compare_at_price`). CSAK akkor írjuk ki, ha tényleg magasabb a
     mostani árnál — valótlan kedvezményt nem jelenítünk meg. */
  function searchMoney(p) {
    const num = v => {
      const n = parseFloat(String(v == null ? '' : v).replace(/\s/g, '').replace(',', '.'));
      return isNaN(n) ? 0 : n;
    };
    const nowRaw = p.price_min != null ? p.price_min : p.price;
    const wasRaw = p.compare_at_price_min != null ? p.compare_at_price_min : p.compare_at_price;
    const now = num(nowRaw);
    const was = num(wasRaw);
    const onSale = was > now && now > 0;
    let html = '<span class="at-search-result-now' + (onSale ? ' is-sale' : '') + '">' +
               formatPrice(nowRaw) + '</span>';
    if (!onSale) return html;
    html += '<span class="at-search-result-was">' + formatPrice(wasRaw) + '</span>';
    // 2026-09-11: pontos tized-százalék, csonkolva (mint a tn-pct.liquid)
    const pct10 = Math.floor(((was - now) * 1000) / was + 1e-9);
    if (pct10 >= 1) html += '<span class="at-search-result-off">-' + Math.floor(pct10 / 10) + (pct10 % 10 ? ',' + (pct10 % 10) : '') + '%</span>';
    return html;
  }

  function formatPrice(rawPrice) {
    let formatted = String(rawPrice);
    if (!/^[\d\s.,]+$/.test(formatted.trim())) return formatted;
    const cleanStr = formatted.replace(/\s/g, '').replace(',', '.');
    const value = parseFloat(cleanStr);
    if (isNaN(value)) return formatted;
    const cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'HUF';
    if (cur === 'HUF') return new Intl.NumberFormat('hu-HU', { style: 'decimal', maximumFractionDigits: 0 }).format(value) + ' Ft';
    if (cur === 'EUR') return '€' + value.toFixed(2).replace('.', ',');
    if (cur === 'RON') return value.toFixed(0) + ' Lei';
    if (cur === 'PLN') return value.toFixed(2).replace('.', ',') + ' zł';
    return value + ' ' + cur;
  }

  function vendorPriority(vendor) {
    if (vendor === 'Márkaspecifikus multimédia') return 2;
    if (vendor === 'Márkaspecifikus tolatókamera') return 1;
    return 0;
  }

  /* A gyors kereső csoportjai — a sorrend a listáé is. A /search/suggest.json
     nem ad metamezőt, ezért a gyártó dönt; a boltban ezek a nevek élnek. */
  const searchGroups = [
    { key: 'android', title: 'Android fejegységek', vendors: ['márkaspecifikus multimédia'] },
    { key: 'xtrons',  title: 'Xtrons fejegységek',  vendors: ['xtrons'] },
    { key: 'pioneer', title: 'Pioneer szettek',     vendors: ['pioneer'] },
    { key: 'kenwood', title: 'Kenwood szettek',     vendors: ['kenwood'] },
    { key: 'jbl',     title: 'JBL szettek',         vendors: ['jbl'] },
    { key: 'camera',  title: 'Tolatókamerák',       vendors: ['márkaspecifikus tolatókamera'] },
    { key: 'other',   title: 'Egyéb találatok',     vendors: [] }
  ];

  /* ── Relevancia (2026-09-21) ────────────────────────────────────────────
     A /search/suggest.json lazán illeszt: „golf 6"-ra a Golf 7 is visszajön.
     A keresőoldal (sections/tn-search.liquid) ezt már szűri — minden beírt
     szónak szerepelnie kell a címben, a gyártóban vagy a terméktípusban,
     ékezet- és kisbetű-függetlenül, 6+ betűs szónál a tő is elég. Ugyanaz a
     szabály itt is, hogy a lenyíló és a keresőoldal ne mondjon mást.
     Ha a szigorú szűrés semmit nem hagy, a laza lista marad — üres lenyílót
     nem adunk vissza. */
  function foldText(s) {
    return String(s == null ? '' : s).toLowerCase()
      .replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i')
      .replace(/ó|ö|ő/g, 'o').replace(/ú|ü|ű/g, 'u')
      .replace(/["',\/()\-.]/g, ' ');
  }
  function queryTokens(q) {
    return foldText(q).split(/\s+/).filter(t => t.length >= 2 || /^\d+$/.test(t));
  }
  function relevantProducts(products, query) {
    const tokens = queryTokens(query);
    if (!tokens.length) return products;
    const hit = products.filter(p => {
      const hay = foldText([p.title, p.vendor, p.product_type].join(' '));
      return tokens.every(t =>
        hay.indexOf(t) >= 0 || (t.length >= 6 && hay.indexOf(t.slice(0, t.length - 2)) >= 0)
      );
    });
    return hit.length ? hit : products;
  }

  /* A találatok csoportonként, saját címsorral. Egyetlen csoportnál nincs
     címsor — ott csak zaj lenne. */
  function groupedResultsHtml(products, card) {
    const buckets = searchGroups.map(g => ({ g, items: [] }));
    products.forEach(p => {
      const v = String(p.vendor || '').trim().toLowerCase();
      const hit = buckets.find(b => b.g.vendors.indexOf(v) >= 0) || buckets[buckets.length - 1];
      hit.items.push(p);
    });
    const used = buckets.filter(b => b.items.length);
    if (used.length < 2) return products.map(card).join('');
    return used.map(b =>
      `<div class="at-search-group"><span>${b.g.title}</span><em>${b.items.length}</em></div>`
      + b.items.map(card).join('')
    ).join('');
  }

  /* Fejléc-kereső lenyíló (2026-09-06, fejléc v4): kattintás a formon kívülre / Esc zár,
     a mező fókusza (ha már van találat) újranyit. A listát az initPredictiveSearchFor tölti. */
  function initHeaderSearchDropdown() {
    const form = document.querySelector('.tn-hs[data-search-scope]');
    if (!form) return;
    const input = form.querySelector('[data-search-input]');
    const results = form.querySelector('[data-search-results]');
    if (!input || !results) return;
    input.addEventListener('focus', () => {
      if (input.value.trim().length > 1 && results.innerHTML.trim()) results.classList.add('is-visible');
    });
    document.addEventListener('click', e => {
      if (!form.contains(e.target)) results.classList.remove('is-visible');
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && results.classList.contains('is-visible')) { results.classList.remove('is-visible'); input.blur(); }
    });
  }

  function initPredictiveSearch() {
    // 2026-09-06 (fejléc v4): több kereső-mező él egyszerre (fejléc-mező asztalon, overlay
    // mobilon) — mindegyik a SAJÁT data-search-scope-ján belüli [data-search-results]-be ír.
    document.querySelectorAll('[data-search-input]').forEach(initPredictiveSearchFor);
  }
  function initPredictiveSearchFor(input) {
    const scope = input.closest('[data-search-scope]') || document;
    const results = scope.querySelector('[data-search-results]');
    const searchUrl = (document.documentElement.dataset.searchUrl) || '/search';
    const strings = (window.theme && window.theme.strings && window.theme.strings.custom && window.theme.strings.custom.search) || {
      view_all: 'View all', no_results: 'No results found', min_chars: 'Type at least 2 characters',
    };
    if (!input || !results) return;

    let timer;
    input.addEventListener('input', e => {
      clearTimeout(timer);
      timer = setTimeout(() => runSearch(e.target.value), 120);
    });

    function runSearch(rawQuery) {
      const original = rawQuery.trim();
      const primary  = normalizeCarModelQuery(rawQuery);
      if (original.length === 0) {
        results.innerHTML = '';
        results.classList.remove('is-visible');
        return;
      }
      if (original.length === 1) {
        results.innerHTML = `<div class="at-search-empty">${strings.min_chars}</div>`;
        results.classList.add('is-visible');
        return;
      }

      // Query variánsok — az ORIGINAL legyen az ELSŐ (legnagyobb relevancia),
      // utána a normalize-elt (ha más), végül szóköz/kötőjel-mentes fallback.
      const variants = [original];
      if (primary && primary !== original) variants.push(primary);
      const stripped = original.replace(/[\s\-\.]/g, '');
      if (stripped !== original && stripped.length > 1 && !variants.includes(stripped)) {
        variants.push(stripped);
      }

      // Loading állapot azonnal látszódjék, ne villogjon a régi tartalom
      results.innerHTML = `
        <div class="tn-loader-wrap" role="status" aria-live="polite">
          <div class="tn-loader-dots"><span></span><span></span><span></span></div>
          <p class="tn-loader-text">Keresés folyamatban…</p>
        </div>`;
      results.classList.add('is-visible');

      Promise.all(variants.map(v =>
        fetch(`/search/suggest.json?q=${encodeURIComponent(v)}&resources[type]=product&resources[limit]=10`).then(r => r.json())
      )).then(allData => {
        const seen = new Set();
        let products = [];
        // Az első variáns (= original) találatai kerülnek elsőként a tömbbe;
        // a további variánsok csak új ID-ket adnak hozzá.
        for (const data of allData) {
          for (const p of (data.resources && data.resources.results && data.resources.results.products) || []) {
            if (!seen.has(p.id)) { seen.add(p.id); products.push(p); }
          }
        }
        products = relevantProducts(products, original);
        if (!products.length) {
          results.innerHTML = `<div class="at-search-empty">${strings.no_results}</div>`;
          results.classList.add('is-visible');
          return;
        }

        // === RELEVANCIA RENDEZÉS ===
        // 1. EXACT title-match (a teljes original query benne van a title-ban)
        // 2. Vendor priority (Márkaspecifikus multimédia = 2, tolatókamera = 1)
        // 3. Eredeti API-sorrend (Shopify saját relevancia)
        const origLower = original.toLowerCase();
        const origNoSpace = origLower.replace(/\s+/g, '');
        products.forEach((p, i) => {
          const tLower = String(p.title || '').toLowerCase();
          const tNoSpace = tLower.replace(/\s+/g, '');
          p.__titleHit = tLower.includes(origLower) || tNoSpace.includes(origNoSpace);
          p.__origIdx = i; // tie-breaker
        });
        products.sort((a, b) => {
          // 1. Title-mátch elöl
          if (a.__titleHit !== b.__titleHit) return a.__titleHit ? -1 : 1;
          // 2. Vendor priority
          const vp = vendorPriority(b.vendor) - vendorPriority(a.vendor);
          if (vp !== 0) return vp;
          // 3. Stabil sorrend
          return a.__origIdx - b.__origIdx;
        });

        const cardHtml = p => `
          <a href="${p.url}" class="at-search-result">
            <div class="at-search-result-image">
              <img src="${searchThumb(p.image, 200)}" alt="${escapeHtml(p.title)}" loading="lazy" width="96" height="96">
            </div>
            <div class="at-search-result-info">
              <div class="at-search-result-title">${escapeHtml(p.title)}</div>
              <div class="at-search-result-price">${searchMoney(p)}</div>
            </div>
            <svg class="at-search-result-arrow" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
              <path fill="currentColor" d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
            </svg>
          </a>`;

        // 2026-09-21: ugyanarra az autóra négyféle megoldás jön — androidos,
        // Xtrons, Pioneer, Kenwood. Egy listába ömlesztve nem lehet eligazodni,
        // ezért csoportonként, saját címsorral jelennek meg (ahogy a /search
        // oldalon is).
        const productsHtml = groupedResultsHtml(products, cardHtml);
        // "Összes találat megtekintése" — AZ EREDETI query az URL-ben és a label-ben
        const viewAllHtml = `
          <a href="${searchUrl}?q=${encodeURIComponent(original)}&type=product" class="at-search-view-all">
            <span>${strings.view_all} ("${escapeHtml(original)}")</span>
            <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
              <path fill="currentColor" d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>
            </svg>
          </a>`;
        results.innerHTML = productsHtml + viewAllHtml;
        results.classList.add('is-visible');
      }).catch(err => {
        console.error('Search error:', err);
      });
    }
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, m => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[m]));
  }
})();
